import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { DocumentTextIcon, ListBulletIcon, XMarkIcon } from '@heroicons/react/24/outline'

import ModalContainer from 'components/ModalContainer'
import { Button, Card, Table } from 'components/gsys-ui'
import { useInvoice } from 'util/queries'

const ViewLinesModal = NiceModal.create(({ lines }) => {
  const modal = useModal()

  return (
    <ModalContainer>
      <Card className="!w-[600px]">
        <Card.Title Icon={ListBulletIcon}>
          Return details
        </Card.Title>
        <Card.Body>
          <LinesTable data={lines} />
          <div className="flex justify-end mt-2">
            <Button Icon={XMarkIcon} variant="white" onClick={modal.remove}>Close</Button>
          </div>
        </Card.Body>
      </Card>
    </ModalContainer>
  )
})

const LinesTable = ({ data }) => {
  return (
    <Table
      data={data}
      columns={[
        {
          header: 'PART',
          accessorKey: 'PartNo'
        },
        {
          header: 'DESCRIPTION',
          accessorKey: 'Desc'
        },
        {
          header: 'QTY',
          accessorKey: 'Qty'
        },
        {
          header: 'REASON',
          accessorKey: 'Reason'
        }
      ]}
    />
  )
}

export default ViewLinesModal